import {
  u
} from "./chunk--chunk-WRROHUGO.vbt.js";
import {
  createSearchController_default
} from "./chunk--chunk-W442N5LJ.vbt.js";
import "./chunk--chunk-CLQRDST3.vbt.js";
import "./chunk--chunk-KT5WPKG4.vbt.js";
import "./chunk--chunk-CXHJB7BK.vbt.js";
import {
  ControllerTypes
} from "./chunk--chunk-HKR66ONA.vbt.js";
import {
  Client,
  Logger,
  Tracker
} from "./chunk--chunk-XJAOVGY2.vbt.js";
import {
  AppMode,
  DomTargeter,
  cookies,
  featureFlags,
  getContext,
  require_cjs,
  url,
  version
} from "./chunk--chunk-GSFZ3OSC.vbt.js";
import {
  configure
} from "./chunk--chunk-SSDFD27P.vbt.js";
import {
  B,
  init_preact_module
} from "./chunk--chunk-W3GMSKXN.vbt.js";
import {
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// node_modules/@searchspring/snap-preact/dist/esm/Snap.js
init_preact_module();
var import_deepmerge2 = __toESM(require_cjs());

// node_modules/is-plain-object/dist/is-plain-object.mjs
function isObject(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function isPlainObject(o) {
  var ctor, prot;
  if (isObject(o) === false)
    return false;
  ctor = o.constructor;
  if (ctor === void 0)
    return true;
  prot = ctor.prototype;
  if (isObject(prot) === false)
    return false;
  if (prot.hasOwnProperty("isPrototypeOf") === false) {
    return false;
  }
  return true;
}

// node_modules/@searchspring/snap-preact/dist/esm/getInitialUrlState/getInitialUrlState.js
var VALID_ACTIONS = ["merge", "set"];
var DEFAULT_IGNORE_PARAMETERS = ["query", "tag", "oq", "fallbackQuery"];
var getInitialUrlState = (intitialStateConfig, urlManager) => {
  const { parameters } = intitialStateConfig;
  const useDefaultIgnoreParameters = intitialStateConfig.settings?.useDefaultIgnoreParameters ?? true;
  let globalIgnoreParameters = intitialStateConfig?.settings?.ignoreParameters || [];
  globalIgnoreParameters = useDefaultIgnoreParameters ? globalIgnoreParameters.concat(DEFAULT_IGNORE_PARAMETERS) : globalIgnoreParameters;
  const initialUrlState = urlManager;
  let newUrlState = urlManager.merge({});
  Object.keys(parameters).forEach((param) => {
    const action = parameters[param].action || "merge";
    const { state } = parameters[param];
    const ignoreParameters = parameters[param].ignoreParameters || [];
    const useGlobalIgnoreParameters = parameters[param].useGlobalIgnoreParameters ?? true;
    const specificIgnoreParameters = useGlobalIgnoreParameters ? globalIgnoreParameters.concat(ignoreParameters) : ignoreParameters;
    const applyState = Boolean(Object.keys(initialUrlState.state).filter((key) => !specificIgnoreParameters.includes(key)).length == 0);
    if (state && applyState && VALID_ACTIONS.includes(action)) {
      newUrlState = newUrlState[action](param, state);
    }
  });
  return newUrlState;
};

// node_modules/@searchspring/snap-preact/dist/esm/configureSnapFeatures.js
var import_deepmerge = __toESM(require_cjs());
function configureSnapFeatures(config2) {
  configureIntegratedSpellCorrection(config2);
}
function configureIntegratedSpellCorrection(config2) {
  if (config2.features?.integratedSpellCorrection?.enabled) {
    if (config2.client) {
      config2.client.config = (0, import_deepmerge.default)({
        autocomplete: {
          requesters: {
            suggest: {
              globals: {
                integratedSpellCorrection: true
              }
            }
          }
        }
      }, config2.client.config || {});
    }
    Object.keys(config2?.controllers || {}).forEach((type) => {
      switch (type) {
        case "autocomplete": {
          config2.controllers[type].forEach((controller) => {
            if (typeof controller.config?.settings?.integratedSpellCorrection == "undefined") {
              controller.config.settings = (0, import_deepmerge.default)({ integratedSpellCorrection: true }, controller.config.settings || {});
            }
            if (controller.config?.settings?.integratedSpellCorrection) {
              controller.config.globals = (0, import_deepmerge.default)({
                search: {
                  query: {
                    spellCorrection: true
                  }
                }
              }, controller.config.globals || {});
            }
          });
          break;
        }
      }
    });
  }
}

// node_modules/@searchspring/snap-preact/dist/esm/Snap.js
configure({ useProxies: "never", isolateGlobalState: true, enforceActions: "never" });
var BRANCH_COOKIE = "ssBranch";
var DEV_COOKIE = "ssDev";
var STYLESHEET_CLASSNAME = "ss-snap-bundle-styles";
var SESSION_ATTRIBUTION = "ssAttribution";
var COMPONENT_ERROR = `Uncaught Error - Invalid value passed as the component.
This usually happens when you pass a JSX Element, and not a function that returns the component, in the snap config. 
		
		instead of - 

	targeters: [
		{
			selector: '#searchspring-content',
			hideTarget: true,
			component: <Content/>,
		},
	]

		or - 

	targeters: [
		{
			selector: '#searchspring-content',
			hideTarget: true,
			component: Content,
		},
	]

		please try - 

	targeters: [
		{
			selector: '#searchspring-content',
			hideTarget: true,
			component: () => Content
		},
	]

The error above happened in the following targeter in the Snap Config`;
var Snap = class {
  constructor(config2, services) {
    this.mode = AppMode.production;
    this._instantiatorPromises = {};
    this._controllerPromises = {};
    this.controllers = {};
    this.getInstantiator = (id) => {
      return this._instantiatorPromises[id] || Promise.reject(`getInstantiator could not find instantiator with id: ${id}`);
    };
    this.getController = (id) => {
      return this._controllerPromises[id] || Promise.reject(`getController could not find controller with id: ${id}`);
    };
    this.getControllers = (...controllerIds) => {
      const getControllerPromises = [];
      controllerIds.forEach((id) => getControllerPromises.push(this.getController(id)));
      return Promise.all(getControllerPromises);
    };
    this.createController = async (type, config3, services2, urlConfig, context2, callback) => {
      if (typeof this._controllerPromises[config3.id] != "undefined") {
        throw new Error(`Controller with id '${config3.id}' is already defined`);
      }
      this._controllerPromises[config3.id] = new Promise((resolve) => this._createController(type, config3, services2, urlConfig, context2, async (cntrlr) => {
        if (typeof callback == "function")
          await callback(cntrlr);
        resolve(cntrlr);
      }));
      return this._controllerPromises[config3.id];
    };
    this._createController = async (type, config3, services2, urlConfig, context2, callback) => {
      let importPromise;
      switch (type) {
        case ControllerTypes.autocomplete:
          importPromise = import("./chunk--createAutocompleteController-TGH7YAQE.vbt.js");
          break;
        case ControllerTypes.finder:
          importPromise = import("./chunk--createFinderController-UBSYLFRL.vbt.js");
          break;
        case ControllerTypes.recommendation:
          importPromise = import("./chunk--createRecommendationController-2LFV7RYT.vbt.js");
          break;
        case ControllerTypes.search:
        default:
          importPromise = import("./chunk--createSearchController-TS6Z7YBF.vbt.js");
          break;
      }
      const creationFunc = (await importPromise).default;
      if (!this.controllers[config3.id]) {
        window.searchspring.controller = window.searchspring.controller || {};
        window.searchspring.controller[config3.id] = this.controllers[config3.id] = creationFunc({
          mode: this.mode,
          url: (0, import_deepmerge2.default)(this.config.url || {}, urlConfig || {}),
          controller: config3,
          context: (0, import_deepmerge2.default)(this.context || {}, context2 || {})
        }, {
          client: services2?.client || this.client,
          store: services2?.store,
          urlManager: services2?.urlManager,
          eventManager: services2?.eventManager,
          profiler: services2?.profiler,
          logger: services2?.logger,
          tracker: services2?.tracker || this.tracker
        });
      }
      if (callback) {
        await callback(this.controllers[config3.id]);
      }
      return this.controllers[config3.id];
    };
    this.handlers = {
      error: (event) => {
        try {
          const { filename } = event;
          if (filename.includes("snapui.searchspring.io") && filename.endsWith(".js") && this.tracker.track.error) {
            const { colno, lineno, error: { stack }, message, timeStamp } = event;
            const href = window.location.href;
            const beaconPayload = {
              href,
              filename,
              stack,
              message,
              colno,
              lineno,
              errortimestamp: timeStamp
            };
            this.tracker.track.error(beaconPayload);
          }
        } catch (e) {
        }
      }
    };
    window.removeEventListener("error", this.handlers.error);
    window.addEventListener("error", this.handlers.error);
    this.config = config2;
    let globalContext = {};
    try {
      globalContext = getContext(["shopper", "config", "merchandising", "siteId"]);
    } catch (err) {
      console.error("Snap failed to find global context");
    }
    this.config = (0, import_deepmerge2.default)(this.config || {}, globalContext.config || {}, {
      isMergeableObject: isPlainObject
    });
    this.context = (0, import_deepmerge2.default)(this.config.context || {}, globalContext || {}, {
      isMergeableObject: isPlainObject
    });
    if (!this.config?.client?.globals?.siteId && this.context.siteId) {
      const defaultClientConfig = {
        globals: {
          siteId: this.context.siteId
        }
      };
      this.config.client = (0, import_deepmerge2.default)(this.config.client || {}, defaultClientConfig);
    }
    if ((!services?.client || !services?.tracker) && !this.config?.client?.globals?.siteId) {
      throw new Error(`Snap: config provided must contain a valid config.client.globals.siteId value`);
    }
    if (this.config.client?.globals && this.context.merchandising?.segments) {
      if (this.config.client.globals?.merchandising) {
        this.config.client.globals.merchandising.segments = (0, import_deepmerge2.default)(this.config.client.globals.merchandising.segments, this.context.merchandising.segments);
      } else {
        this.config.client.globals.merchandising = {
          segments: this.context.merchandising.segments
        };
      }
    }
    try {
      const urlParams = url(window.location.href);
      const branchOverride = urlParams?.params?.query?.branch || cookies.get(BRANCH_COOKIE);
      if (Object.values(AppMode).includes("development")) {
        this.mode = "development";
      }
      if (this.config.mode && Object.values(AppMode).includes(this.config.mode)) {
        this.mode = this.config.mode;
      }
      if (urlParams?.params?.query && "dev" in urlParams.params.query || !!cookies.get(DEV_COOKIE)) {
        if (urlParams?.params.query?.dev == "false" || urlParams?.params.query?.dev == "0") {
          cookies.unset(DEV_COOKIE);
          this.mode = AppMode.production;
        } else {
          cookies.set(DEV_COOKIE, "1", "Lax", 0);
          this.mode = AppMode.development;
        }
      }
      if (this.config.client) {
        this.config.client.config = this.config.client.config || {};
        this.config.client.config.mode = this.config.client.config.mode || this.mode;
      }
      configureSnapFeatures(this.config);
      this.client = services?.client || new Client(this.config.client.globals, this.config.client.config);
      this.logger = services?.logger || new Logger({ prefix: "Snap Preact ", mode: this.mode });
      const trackerGlobals = this.config.tracker?.globals || this.config.client.globals;
      const trackerConfig = (0, import_deepmerge2.default)(this.config.tracker?.config || {}, { framework: "preact", mode: this.mode });
      this.tracker = services?.tracker || new Tracker(trackerGlobals, trackerConfig);
      const sessionAttribution = window.sessionStorage?.getItem(SESSION_ATTRIBUTION);
      if (urlParams?.params?.query?.ss_attribution) {
        const attribution = urlParams.params.query.ss_attribution.split(":");
        const [type, id] = attribution;
        if (type && id) {
          this.tracker.updateContext("attribution", { type, id });
        }
        window.sessionStorage?.setItem(SESSION_ATTRIBUTION, urlParams.params.query.ss_attribution);
      } else if (sessionAttribution) {
        const [type, id] = sessionAttribution.split(":");
        if (type && id) {
          this.tracker.updateContext("attribution", { type, id });
        }
      }
      this.logger.imageText({
        url: "https://snapui.searchspring.io/favicon.svg",
        text: `[${version}]`,
        style: `color: ${this.logger.colors.indigo}; font-weight: bold;`
      });
      if (branchOverride && !document.querySelector(`script[${BRANCH_COOKIE}]`)) {
        this.logger.warn(`:: loading branch override ~ '${branchOverride}' ...`);
        if (featureFlags.cookies) {
          cookies.set(BRANCH_COOKIE, branchOverride, "Lax", 36e5);
        } else {
          this.logger.warn("Cookies are not supported/enabled by this browser, branch overrides will not persist!");
        }
        let path = `https://snapui.searchspring.io/${this.config.client.globals.siteId}/`;
        const script = document.querySelector('script[src*="//snapui.searchspring.io"]');
        if (script) {
          const scriptRoot = script.getAttribute("src").match(/\/\/snapui.searchspring.io\/[a-zA-Z0-9]{6}\//);
          if (scriptRoot) {
            path = scriptRoot.toString();
          }
        }
        const branchScript = document.createElement("script");
        const src = `${path}${branchOverride}/bundle.js`;
        branchScript.src = src;
        branchScript.setAttribute(BRANCH_COOKIE, branchOverride);
        new DomTargeter([
          {
            selector: "body",
            inject: {
              action: "append",
              element: () => {
                const branchContainer = document.createElement("div");
                branchContainer.id = "searchspring-branch-override";
                return branchContainer;
              }
            }
          }
        ], async (target, elem) => {
          const props = {};
          try {
            const getBundleDetails = (await import("./chunk--getBundleDetails-UAPJ4WYA.vbt.js")).getBundleDetails;
            props.details = await getBundleDetails(src);
          } catch (err) {
            props.error = err;
          }
          const BranchOverride = (await import("./chunk--BranchOverride-YEDWNJOX.vbt.js")).BranchOverride;
          B(u(BranchOverride, { ...props, name: branchOverride, onRemoveClick: () => {
            cookies.unset(BRANCH_COOKIE);
            const urlState = url(window.location.href);
            delete urlState?.params.query["branch"];
            const newUrl = urlState?.url();
            if (newUrl && newUrl != window.location.href) {
              window.location.href = newUrl;
            } else {
              window.location.reload();
            }
          } }), elem);
          try {
            delete window.searchspring;
          } catch (e) {
            window.searchspring = void 0;
          }
          document.head.appendChild(branchScript);
        });
        document.querySelectorAll(`.${STYLESHEET_CLASSNAME}`).forEach((el) => el.remove());
        throw "branch override";
      }
    } catch (e) {
      if (e == "branch override") {
        throw `${this.logger.emoji.bang} Snap instantiation halted - using branch override.`;
      }
      this.logger.error(e);
    }
    window.searchspring = window.searchspring || {};
    window.searchspring.context = this.context;
    if (this.client)
      window.searchspring.client = this.client;
    if (this.context?.shopper?.id) {
      this.tracker.track.shopper.login({
        id: this.context.shopper.id
      });
    }
    if (this.context?.shopper?.cart) {
      const cart = this.context.shopper.cart;
      if (Array.isArray(cart)) {
        const cartItems = cart.filter((item) => item?.sku || item?.childSku).map((item) => (item?.sku || item?.childSku || "").trim());
        this.tracker.cookies.cart.set(cartItems);
      }
    }
    Object.keys(this.config?.controllers || {}).forEach((type) => {
      switch (type) {
        case "search": {
          this.config.controllers[type].forEach((controller, index) => {
            try {
              if (typeof this._controllerPromises[controller.config.id] != "undefined") {
                this.logger.error(`Controller with id '${controller.config.id}' is already defined`);
                return;
              }
              const cntrlr = createSearchController_default({
                mode: this.mode,
                url: (0, import_deepmerge2.default)(this.config.url || {}, controller.url || {}),
                controller: controller.config,
                context: (0, import_deepmerge2.default)(this.context || {}, controller.context || {})
              }, {
                client: controller.services?.client || this.client,
                store: controller.services?.store,
                urlManager: controller.services?.urlManager,
                eventManager: controller.services?.eventManager,
                profiler: controller.services?.profiler,
                logger: controller.services?.logger,
                tracker: controller.services?.tracker || this.tracker
              });
              window.searchspring.controller = window.searchspring.controller || {};
              window.searchspring.controller[cntrlr.config.id] = this.controllers[cntrlr.config.id] = cntrlr;
              this._controllerPromises[cntrlr.config.id] = new Promise((resolve) => resolve(cntrlr));
              let searched = false;
              const runSearch = () => {
                if (!searched) {
                  if (controller.url?.initial) {
                    getInitialUrlState(controller.url.initial, cntrlr.urlManager).go({ history: "replace" });
                  }
                  searched = true;
                  this.controllers[controller.config.id].search();
                }
              };
              const targetFunction = async (target, elem, originalElem) => {
                runSearch();
                const onTarget = target.onTarget;
                onTarget && await onTarget(target, elem, originalElem);
                try {
                  const Component = await target.component();
                  setTimeout(() => {
                    B(u(Component, { controller: this.controllers[controller.config.id], ...target.props }), elem);
                  });
                } catch (err) {
                  this.logger.error(err);
                  this.logger.error(COMPONENT_ERROR, target);
                }
              };
              controller?.targeters?.forEach((target, target_index) => {
                if (!target.selector) {
                  throw new Error(`Targets at index ${target_index} missing selector value (string).`);
                }
                if (!target.component) {
                  throw new Error(`Targets at index ${target_index} missing component value (Component).`);
                }
                if (target.prefetch) {
                  runSearch();
                }
                cntrlr.createTargeter({ controller: cntrlr, ...target }, async (target2, elem, originalElem) => {
                  if (target2 && target2.skeleton && elem) {
                    const Skeleton = await target2.skeleton();
                    setTimeout(() => {
                      B(u(Skeleton, {}), elem);
                    });
                  }
                  targetFunction(target2, elem, originalElem);
                });
              });
            } catch (err) {
              this.logger.error(`Failed to instantiate ${type} controller at index ${index}.`, err);
            }
          });
          break;
        }
        case "autocomplete": {
          this.config.controllers[type].forEach((controller, index) => {
            if (typeof this._controllerPromises[controller.config.id] != "undefined") {
              this.logger.error(`Controller with id '${controller.config.id}' is already defined`);
              return;
            }
            this._controllerPromises[controller.config.id] = new Promise(async (resolve) => {
              try {
                let bound = false;
                const runBind = () => {
                  if (!bound) {
                    bound = true;
                    setTimeout(() => {
                      this.controllers[controller.config.id].bind();
                    });
                  }
                };
                const targetFunction = async (target, elem, originalElem) => {
                  const onTarget = target.onTarget;
                  onTarget && await onTarget(target, elem, originalElem);
                  try {
                    const Component = await target.component();
                    setTimeout(() => {
                      B(u(Component, { controller: this.controllers[controller.config.id], input: originalElem, ...target.props }), elem);
                    });
                  } catch (err) {
                    this.logger.error(err);
                    this.logger.error(COMPONENT_ERROR, target);
                  }
                };
                if (!controller?.targeters || controller?.targeters.length === 0) {
                  await this._createController(ControllerTypes.autocomplete, controller.config, controller.services, controller.url, controller.context, (cntrlr) => {
                    if (cntrlr)
                      resolve(cntrlr);
                  });
                  runBind();
                }
                controller?.targeters?.forEach((target, target_index) => {
                  if (!target.selector) {
                    throw new Error(`Targets at index ${target_index} missing selector value (string).`);
                  }
                  if (!target.component) {
                    throw new Error(`Targets at index ${target_index} missing component value (Component).`);
                  }
                  const targeter = new DomTargeter([
                    {
                      inject: {
                        action: "after",
                        element: () => {
                          const acContainer = document.createElement("div");
                          acContainer.className = "ss__autocomplete--target";
                          acContainer.addEventListener("click", (e) => {
                            e.stopPropagation();
                          });
                          return acContainer;
                        }
                      },
                      ...target
                    }
                  ], async (target2, elem, originalElem) => {
                    const cntrlr = await this._createController(ControllerTypes.autocomplete, controller.config, controller.services, controller.url, controller.context, (cntrlr2) => {
                      if (cntrlr2)
                        resolve(cntrlr2);
                    });
                    runBind();
                    targetFunction({ controller: cntrlr, ...target2 }, elem, originalElem);
                    cntrlr.addTargeter(targeter);
                  });
                });
              } catch (err) {
                this.logger.error(`Failed to instantiate ${type} controller at index ${index}.`, err);
              }
            });
          });
          break;
        }
        case "finder": {
          this.config.controllers[type].forEach((controller, index) => {
            if (typeof this._controllerPromises[controller.config.id] != "undefined") {
              this.logger.error(`Controller with id '${controller.config.id}' is already defined`);
              return;
            }
            this._controllerPromises[controller.config.id] = new Promise((resolve) => {
              try {
                let searched = false;
                const runSearch = () => {
                  if (!searched) {
                    this.controllers[controller.config.id].search();
                    searched = true;
                  }
                };
                const targetFunction = async (target, elem, originalElem) => {
                  const onTarget = target.onTarget;
                  onTarget && await onTarget(target, elem, originalElem);
                  try {
                    const Component = await target.component();
                    setTimeout(() => {
                      B(u(Component, { controller: this.controllers[controller.config.id], ...target.props }), elem);
                    });
                  } catch (err) {
                    this.logger.error(err);
                    this.logger.error(COMPONENT_ERROR, target);
                  }
                };
                if (!controller?.targeters || controller?.targeters.length === 0) {
                  this._createController(ControllerTypes.finder, controller.config, controller.services, controller.url, controller.context, (cntrlr) => {
                    if (cntrlr)
                      resolve(cntrlr);
                  });
                }
                controller?.targeters?.forEach((target, target_index) => {
                  if (!target.selector) {
                    throw new Error(`Targets at index ${target_index} missing selector value (string).`);
                  }
                  if (!target.component) {
                    throw new Error(`Targets at index ${target_index} missing component value (Component).`);
                  }
                  const targeter = new DomTargeter([{ ...target }], async (target2, elem, originalElem) => {
                    const cntrlr = await this._createController(ControllerTypes.finder, controller.config, controller.services, controller.url, controller.context, (cntrlr2) => {
                      if (cntrlr2)
                        resolve(cntrlr2);
                    });
                    runSearch();
                    targetFunction({ controller: cntrlr, ...target2 }, elem, originalElem);
                    cntrlr.addTargeter(targeter);
                  });
                });
              } catch (err) {
                this.logger.error(`Failed to instantiate ${type} controller at index ${index}.`, err);
              }
            });
          });
          break;
        }
        case "recommendation": {
          this.config.controllers[type].forEach((controller, index) => {
            if (typeof this._controllerPromises[controller.config.id] != "undefined") {
              this.logger.error(`Controller with id '${controller.config.id}' is already defined`);
              return;
            }
            this._controllerPromises[controller.config.id] = new Promise((resolve) => {
              try {
                let searched = false;
                const runSearch = () => {
                  if (!searched) {
                    this.controllers[controller.config.id].search();
                    searched = true;
                  }
                };
                const targetFunction = async (target, elem, originalElem) => {
                  const onTarget = target.onTarget;
                  onTarget && await onTarget(target, elem, originalElem);
                  try {
                    const Component = await target.component();
                    setTimeout(() => {
                      B(u(Component, { controller: this.controllers[controller.config.id], ...target.props }), elem);
                    });
                  } catch (err) {
                    this.logger.error(err);
                    this.logger.error(COMPONENT_ERROR, target);
                  }
                };
                if (!controller?.targeters || controller?.targeters.length === 0) {
                  this._createController(ControllerTypes.recommendation, controller.config, controller.services, controller.url, controller.context, (cntrlr) => {
                    if (cntrlr)
                      resolve(cntrlr);
                  });
                }
                controller?.targeters?.forEach((target, target_index) => {
                  if (!target.selector) {
                    throw new Error(`Targets at index ${target_index} missing selector value (string).`);
                  }
                  if (!target.component) {
                    throw new Error(`Targets at index ${target_index} missing component value (Component).`);
                  }
                  const targeter = new DomTargeter([{ ...target }], async (target2, elem, originalElem) => {
                    const cntrlr = await this._createController(ControllerTypes.recommendation, controller.config, controller.services, controller.url, controller.context, (cntrlr2) => {
                      if (cntrlr2)
                        resolve(cntrlr2);
                    });
                    runSearch();
                    targetFunction({ controller: cntrlr, ...target2 }, elem, originalElem);
                    cntrlr.addTargeter(targeter);
                  });
                });
              } catch (err) {
                this.logger.error(`Failed to instantiate ${type} controller at index ${index}.`, err);
              }
            });
          });
          break;
        }
      }
    });
    if (this.config?.instantiators?.recommendation) {
      try {
        this._instantiatorPromises.recommendation = import("./chunk--RecommendationInstantiator-2O3LDDEL.vbt.js").then(({ RecommendationInstantiator }) => {
          this.config.instantiators.recommendation.mode = this.config.instantiators.recommendation.mode || this.mode;
          return new RecommendationInstantiator(this.config.instantiators.recommendation, {
            client: this.client,
            tracker: this.tracker,
            logger: this.logger
          }, this.context);
        });
      } catch (err) {
        this.logger.error(`Failed to create Recommendations Instantiator.`, err);
      }
    }
  }
};

// src/js/searchspring/lib/plugin.js
async function restorePosition({ element }, next) {
  if (!element) {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });
  }
  await next();
}
var plugin = (controller) => {
  controller.on("afterStore", async ({ controller: controller2 }, next) => {
    controller2.log.debug("store", controller2.store.toJSON());
    await next();
  });
  controller.on("restorePosition", restorePosition);
};

// src/js/searchspring/index.jsx
var context = getContext(["collection"]);
var backgroundFilters = [];
if (context.collection?.handle) {
  if (context.collection.handle != "all") {
    backgroundFilters.push({
      field: "collection_handle",
      value: context.collection.handle,
      type: "value",
      background: true
    });
  }
}
var config = {
  mode: "production",
  context,
  features: {
    integratedSpellCorrection: {
      enabled: true
    }
  },
  url: {
    parameters: {
      core: {
        query: { name: "q" }
      }
    }
  },
  client: {
    globals: {
      siteId: ""
    }
  },
  instantiators: {
    recommendation: {
      components: {
        Recommendation: async () => {
          return (await import("./chunk--Recommendation-ERLEJ5QV.vbt.js")).Recommendation;
        }
      },
      config: {
        branch: "production",
        plugins: []
      }
    }
  },
  controllers: {
    search: [
      {
        config: {
          id: "search",
          globals: {
            filters: backgroundFilters
          },
          settings: {
            redirects: {
              singleResult: false
            }
          },
          plugins: [[plugin]]
        },
        targeters: [
          {
            selector: "[data-product-grid]",
            component: async () => {
              return (await import("./chunk--ProductGrid-RFDDHP4Y.vbt.js")).ProductGrid;
            },
            hideTarget: true
          }
        ]
      },
      {
        url: {
          parameters: {
            core: {
              sort: { name: "ps" },
              filter: { name: "pf" },
              page: { name: "pp" }
            }
          }
        },
        config: {
          id: "content",
          globals: {
            siteId: ""
          },
          settings: {
            redirects: {
              singleResult: false
            }
          }
        }
      }
    ],
    autocomplete: [
      {
        config: {
          id: "autocomplete",
          selector: "#search",
          settings: {
            trending: {
              limit: 5
            }
          }
        },
        targeters: [
          {
            selector: "#search",
            component: async () => {
              return (await import("./chunk--Autocomplete-IFFEQYBW.vbt.js")).Autocomplete;
            }
          }
        ]
      },
      {
        config: {
          id: "autocomplete-content",
          selector: "#search",
          globals: {
            siteId: ""
          },
          settings: {
            trending: {
              limit: 8,
              showResults: true
            }
          }
        }
      }
    ],
    recommendation: [
      {
        config: {
          id: "ac-recs",
          // can be changed (change below accordingly)
          tag: "autocomplete-widget",
          // recommendations profile tag - change to desired profile from SMC: https://manage.searchspring.net/management/personalized-recommendations
          branch: "production",
          plugins: []
        }
      }
    ]
  }
};

// src/js/components/Searchspring.js
var Searchspring = class {
  constructor(el, sel) {
    const siteId = el.getAttribute(sel);
    const articlesSiteId = el.getAttribute("data-articles-site-id");
    config.client.globals.siteId = siteId;
    config.controllers.search.forEach((searchConfig) => {
      if (searchConfig.config && searchConfig.config.id === "content") {
        searchConfig.config.globals.siteId = articlesSiteId;
      }
    });
    config.controllers.autocomplete.forEach((acConfig) => {
      if (acConfig.config && acConfig.config.id === "autocomplete-content") {
        acConfig.config.globals.siteId = articlesSiteId;
      }
    });
    if (!window.searchspring) {
      const snap = new Snap(config);
      snap.getControllers("autocomplete-content", "autocomplete", "ac-recs").then(([acContent, ac, acRecs]) => {
        ac.acRecsController = acRecs;
        ac.acContentController = acContent;
        if (!acRecs.store.loaded && !acRecs.store.loading) {
          acRecs.search();
        }
        acContent.bind();
      });
      snap.getControllers("search", "content").then(([search, content]) => {
        search.contentController = content;
        if (!content.store.loaded && !content.store.loading) {
          content.search();
        }
      });
    }
    const toggleList = el.querySelectorAll("[data-searchspring-modal-toggle]");
    const modal = el.querySelector("[data-searchspring-modal]");
    const input = el.querySelector("[data-searchspring-input]");
    const close = el.querySelector("[data-searchspring-modal-close]");
    const header = document.querySelector("[data-header]");
    if (toggleList.length > 0) {
      [...toggleList, close].forEach((el2) => el2.addEventListener("click", () => {
        modal.classList.toggle("hidden");
        modal.style.top = `${header.getBoundingClientRect().top}px`;
        modal.style.height = `calc(100% - ${header.getBoundingClientRect().top}px)`;
        document.body.classList.toggle("locked");
        if (el2 === close) {
          document.body.style.removeProperty("overflow");
          document.body.style.removeProperty("touch-action");
          document.documentElement.style.removeProperty("overflow");
          document.documentElement.style.removeProperty("touch-action");
        } else {
          input.value = "";
          input.dispatchEvent(new Event("input"));
          input.focus();
          document.body.style.overflow = "hidden";
          document.body.style.touchAction = "none";
          document.documentElement.style.overflow = "hidden";
          document.documentElement.style.touchAction = "none";
        }
      }));
    }
    const inputClear = el.querySelector("[data-input-clear]");
    if (inputClear)
      inputClear.addEventListener("click", () => {
        input.value = "";
        input.dispatchEvent(new Event("input"));
        input.focus();
      });
  }
};
var Searchspring_default = Searchspring;
export {
  Searchspring_default as default
};
/*! Bundled license information:

is-plain-object/dist/is-plain-object.mjs:
  (*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   *)
*/
